import { CnForm } from '@/components/cn-form';

export default CnForm;
